(function () {
  'use strict';
  if (window.OxxVnextContent) return;
  const trim = value => String(value || '').trim();
  const positive = value => /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(trim(value)) && Number(value) > 0 && Number.isFinite(Number(value));
  const allowedMaterials = ['NBR', 'FKM', 'EPDM', 'SILICONE', 'FFKM'];
  const WORKSHEET_CONTEXT_KEY = 'oxxring:measurement-worksheet:v1';
  const WORKSHEET_CONTEXT_VERSION = 1;
  const WORKSHEET_CONTEXT_MAX_AGE = 2 * 60 * 60 * 1000;
  const CONTEXT_FIELDS = ['reference', 'ring_condition', 'fluid', 'temperature', 'movement', 'notes'];
  const cleanMaterial = value => ({ VMQ: 'SILICONE', NITRILE: 'NBR', 'BUNA-N': 'NBR' }[trim(value).toUpperCase()] || trim(value).toUpperCase());
  const cleanContextValue = (value, max) => trim(value).replace(/[\u0000-\u001f\u007f]/g, ' ').slice(0, max);
  function getSessionStorage() {
    try { return window.sessionStorage; } catch (_) { return null; }
  }
  function readWorksheetContext() {
    const storage = getSessionStorage();
    if (!storage) return null;
    try {
      const raw = storage.getItem(WORKSHEET_CONTEXT_KEY);
      if (!raw) return null;
      const value = JSON.parse(raw);
      if (!value || value.version !== WORKSHEET_CONTEXT_VERSION || !Number.isFinite(Number(value.saved_at))) return null;
      if (Date.now() - Number(value.saved_at) > WORKSHEET_CONTEXT_MAX_AGE) { storage.removeItem(WORKSHEET_CONTEXT_KEY); return null; }
      return value;
    } catch (_) { return null; }
  }
  function clearWorksheetContext() {
    const storage = getSessionStorage();
    if (!storage) return;
    try { storage.removeItem(WORKSHEET_CONTEXT_KEY); } catch (_) {}
  }
  function saveWorksheetContext(form) {
    const storage = getSessionStorage();
    if (!storage) return false;
    const named = name => form.elements.namedItem(name);
    const context = {
      version: WORKSHEET_CONTEXT_VERSION,
      saved_at: Date.now(),
      units: named('units') && named('units').value === 'in' ? 'in' : 'mm',
      id: cleanContextValue(named('id') && named('id').value, 24),
      cs: cleanContextValue(named('cs') && named('cs').value, 24),
      material: cleanContextValue(named('material') && named('material').value, 32),
      hardness: cleanContextValue(named('hardness') && named('hardness').value, 16),
      quantity: cleanContextValue(named('quantity') && named('quantity').value, 12)
    };
    CONTEXT_FIELDS.forEach(key => {
      const input = form.querySelector('[data-oxc-context-field="' + key + '"]');
      context[key] = cleanContextValue(input && input.value, key === 'notes' ? 1500 : key === 'fluid' ? 180 : key === 'temperature' ? 100 : 120);
    });
    try { storage.setItem(WORKSHEET_CONTEXT_KEY, JSON.stringify(context)); return true; } catch (_) { return false; }
  }
  function normalize(query) {
    const q = { units: query.units === 'in' ? 'in' : 'mm' };
    ['id', 'cs'].forEach(key => { if (positive(query[key])) q[key] = trim(query[key]); });
    const material = cleanMaterial(query.material);
    if (allowedMaterials.includes(material)) q.material = material;
    if (/^(?:50|60|70|75|80|90)$/.test(trim(query.hardness))) q.hardness = trim(query.hardness);
    if (/^[1-9]\d{0,9}$/.test(trim(query.quantity)) && Number(query.quantity) <= 1000000000) q.quantity = trim(query.quantity);
    return q;
  }
  function handoffUrl(query, quote) {
    const q = normalize(query);
    const params = new URLSearchParams({ source: 'size-guide-worksheet', units: q.units, worksheet_context: '1' });
    ['id', 'cs', 'material', 'hardness'].forEach(key => { if (q[key]) params.set(key, q[key]); });
    if (quote) {
      params.set('request_mode', 'NEED_HELP');
      if (q.quantity) params.set('quantity', q.quantity);
      // RFQ accepts a units field. Normalise inches to mm without relabelling the raw readings.
      if (q.units === 'in') {
        params.set('original_unit', 'in');
        ['id', 'cs'].forEach(key => {
          if (!q[key]) return;
          params.set('original_' + key, q[key]);
          params.set(key, String(Number((Number(q[key]) * 25.4).toFixed(8))));
        });
      }
      params.set('units', 'mm');
      params.set('unit', 'mm');
    }
    return (quote ? '/pages/bulk-quote?' : '/pages/size-guide?view=find-o-rings&') + params;
  }
  function inheritedUrl(href, search, origin) {
    const target = new URL(href, origin);
    if (target.origin !== origin || !target.pathname.startsWith('/pages/')) return href;
    const original = new URLSearchParams(search);
    const q = normalize(Object.fromEntries(original));
    // Keep validated context only. Never copy arbitrary URL fields or override the link's material filter.
    ['id', 'cs', 'units', 'material', 'hardness'].forEach(key => {
      if (q[key] && (original.has(key) || key === 'units' && (q.id || q.cs)) && !target.searchParams.has(key)) target.searchParams.set(key, q[key]);
    });
    if (!target.searchParams.has('resolution_context_id')) {
      const id = original.get('resolution_context_id') || '';
      if (/^[a-zA-Z0-9._:-]{1,160}$/.test(id)) target.searchParams.set('resolution_context_id', id);
    }
    return target.pathname + target.search + target.hash;
  }
  function setHeadingLevel(element, tagName) {
    if (!element || element.tagName.toLowerCase() === tagName.toLowerCase()) return element;
    const replacement = element.ownerDocument.createElement(tagName);
    Array.from(element.attributes).forEach(attr => replacement.setAttribute(attr.name, attr.value));
    while (element.firstChild) replacement.appendChild(element.firstChild);
    element.replaceWith(replacement);
    return replacement;
  }
  function init(root) {
    if (root.dataset.oxcReady) return;
    root.dataset.oxcReady = 'true';
    if (root.dataset.oxcPage === 'size-guide') {
      const params = new URLSearchParams(window.location.search);
      const view = params.get('view');
      const tool = params.get('tool');
      if (view === 'find-o-rings') {
        root.hidden = true;
        const finder = document.getElementById('oxc-finder-view');
        if (finder) {
          finder.hidden = false;
          setHeadingLevel(root.querySelector('h1'), 'h2');
          setHeadingLevel(finder.querySelector('[data-oxx-finder-heading]'), 'h1');
        }
        return;
      }
      if (tool === 'failure-diagnostic') {
        root.hidden = true;
        const diagnostic = document.getElementById('oxc-failure-diagnostic-view');
        if (diagnostic) {
          diagnostic.hidden = false;
          setHeadingLevel(root.querySelector('h1'), 'h2');
          setHeadingLevel(diagnostic.querySelector('[data-oxx-failure-heading]'), 'h1');
        }
        return;
      }
    }
    root.querySelectorAll('[data-oxc-context]').forEach(link => {
      link.href = inheritedUrl(link.getAttribute('href'), window.location.search, window.location.origin);
    });
    root.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const detail = event.target.closest('.oxc-help[open]');
      if (detail) { detail.open = false; detail.querySelector('summary').focus(); }
    });
    const form = root.querySelector('[data-oxc-worksheet]');
    if (!form) return;
    const error = form.querySelector('[data-oxc-error]');
    const field = name => form.elements.namedItem(name);
    const initial = normalize(Object.fromEntries(new URLSearchParams(window.location.search)));
    Object.entries(initial).forEach(([name, value]) => { const element = field(name); if (element && (!element.value || name === 'units')) element.value = value; });
    const stored = readWorksheetContext();
    if (stored) {
      CONTEXT_FIELDS.forEach(key => {
        const input = form.querySelector('[data-oxc-context-field="' + key + '"]');
        if (input && !input.value && stored[key]) input.value = stored[key];
      });
    }
    function update() {
      const id = field('id').value, cs = field('cs').value;
      error.hidden = true;
      form.querySelectorAll('[data-oxc-print-field]').forEach(input => {
        const value = input.nextElementSibling;
        if (!value || !value.classList.contains('oxc-print-value')) return;
        value.textContent = input.tagName === 'SELECT' ? input.options[input.selectedIndex].textContent : input.value || '—';
      });
    }
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('reset', () => { clearWorksheetContext(); window.setTimeout(update, 0); });
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!positive(field('id').value) || !positive(field('cs').value)) {
        error.textContent = 'Enter an inside diameter and cross section greater than zero.';
        error.hidden = false;
        (!positive(field('id').value) ? field('id') : field('cs')).focus();
        return;
      }
      const quote = Boolean(event.submitter && event.submitter.hasAttribute('data-oxc-quote'));
      saveWorksheetContext(form);
      window.location.assign(handoffUrl(Object.fromEntries(new FormData(form)), quote));
    });
    function preparePrint() { update(); document.body.classList.add('oxc-printing'); }
    window.addEventListener('beforeprint', preparePrint);
    window.addEventListener('afterprint', () => document.body.classList.remove('oxc-printing'));
    root.querySelectorAll('[data-oxc-print]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => { preparePrint(); window.print(); });
    });
    update();
  }
  window.OxxVnextContent = { normalize, handoffUrl, inheritedUrl, init, readWorksheetContext, clearWorksheetContext };
  const start = () => document.querySelectorAll('[data-oxc-page]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
